import { render, staticRenderFns } from "./InfoPointDetails.vue?vue&type=template&id=ca880ef6&"
import script from "./InfoPointDetails.vue?vue&type=script&lang=js&"
export * from "./InfoPointDetails.vue?vue&type=script&lang=js&"
import style0 from "./InfoPointDetails.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports